import RequestHandler from "./RequestHandler";

function FavoriteProductsAPI() {
    const baseFavoriteAPI = "favorite-products";

    async function toggleFavoriteProduct(productId) {
        try {
            const result = await RequestHandler.post(
                `${baseFavoriteAPI}/favorite/${productId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        toggleFavoriteProduct,
    };
}

export default FavoriteProductsAPI();
